<template>
    <div :style="{ height: `${this.vh - 170}px` }" class="flex align-items-center justify-content-center pt-3 pb-3">
      
      <div >
        <div id="qrCodeScanner" style="width: 350px; height: auto;"></div>          
               
        <div class="field flex justify-content-center">
          <PrimevueButton @click="stopScanner" label="Zastaviť skenovanie" 
            
            severity="danger" text raised class="mt-2 w-full mb-2 basic-menu uppercase"/>
        </div>
      </div>
    </div>
</template>
  
<script>
import { Html5Qrcode, Html5QrcodeScanType } from "html5-qrcode"; 
import Security from './security'
import {store} from './store'
import PrimevueButton from 'primevue/button';
import router from "@/router";
import notie from "notie/dist/notie";

  export default {
    name: "QrCodeScanner",
    components:{
      PrimevueButton,

  },
    data() {
      return {
        store,
        qrCodeResult: null,
        html5QrCode: null,
        isScanning: false,
        vh: 0,
        vw: 0,
      };
    },
    methods: {
      startScanner() {
   
        this.html5QrCode = new Html5Qrcode("qrCodeScanner");
        // Dynamic QR box size based on screen width    style="width: 400px; height: 260px;" :style="{ height: `${this.vh - 400}px`, width: `${this.vw}px` }"
        const qrBoxSize = Math.min(180, window.innerWidth * 0.5);

        const config = {
          fps: 20, // Higher FPS for better performance
          qrbox: { width: qrBoxSize, height: qrBoxSize * 0.9 }, // Maintain aspect ratio
          aspectRatio: 1.5, // Prevent distortion
          supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA], // Ensure camera scanning
        };

        //const config = {
        //  fps: 10,
        //  qrbox: { width: 100, height: 100 },
        //};
        let lastScanTime = 0;
        this.html5QrCode.start(
            { 
              facingMode: "environment" ,
 
            }, // Používa zadnú kameru
            config,
            (decodedText) => {
              const now = new Date().getTime();
                if (now - lastScanTime > 1000) {  // 1-sekundový odstup medzi skenmi
                  lastScanTime = now;
                  this.qrCodeResult = decodedText;
                  this.stopScanner();
                  this.loadItem();
                }
            },
            (errorMessage) => {
              console.log("Chyba pri čítaní QR kódu: ", errorMessage);
            }
          )
          .then(() => {
            this.isScanning = true;
          })
          .catch((err) => {
            console.error("Chyba pri inicializácii skenera: ", err);
          });
      },

      stopScanner() {
        if (this.html5QrCode) {
          this.html5QrCode.stop().then(() => {
            this.isScanning = false;
          });
        }
        router.push("/mod-stock");
      },

      setDynamicHeight() {
        this.vh = window.innerHeight; // Nastavenie viditeľnej výšky
        this.vw = window.innerWidth;
      },

      loadItem(){
        const typeOfItem = this.qrCodeResult[0]

        let itemName = "kus"
        let url = "stock-item"
        //if (typeOfItem == "Z"){
        //}
        if (typeOfItem == "B"){
           itemName = "balík"
           url = "package"
        }

        if (typeOfItem == "K"){
           itemName = "krabic"
           url = "box"
        }

        fetch(this.store.Api_url + "/v1/"+url+"?query=Code:"+this.qrCodeResult, Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
             
              notie.alert({
                type: 'error',
                text: "Chyba pri vyhľadaní "+itemName+(typeOfItem == "K" ? 'e' : 'a')
              })
            } else {
              if (responseData.data){
                //console.log("Kus: ",responseData)
                const itemId = responseData.data[0].id
                
                if (typeOfItem == "Z"){
                  router.push("/mod-stock/stock-items/"+String(itemId));
                }
                if (typeOfItem == "B"){
                  router.push("/mod-stock/packages/"+String(itemId));
                }
                if (typeOfItem == "K"){
                  router.push("/mod-stock/boxies/"+String(itemId));
                }
              }else{
                notie.alert({
                type: 'error',
                text: typeOfItem == "K" ? 'Hľadaná '+itemName+'a s kódom '+this.qrCodeResult+' sa nenašla' : 'Hľadaný '+itemName+' s kódom '+this.qrCodeResult+' sa nenašiel'
              })
              }
            }
          })
          .catch((error) => {
            //this.$emit('error', "Chyba pri vytváraní kódu kusu" + error);
            notie.alert({
                type: 'error',
                text: "Chyba pri vyhľadaní "+itemName+ ": "+error
              })
        })

      },

    },

    beforeMount() {
      Security.requireToken();

      store.selectModul = this.$route.path.split("/")[1]
      
      this.setDynamicHeight(); 
      window.addEventListener("resize", this.setDynamicHeight);
    },

    mounted() {
      this.startScanner();
    },
    beforeUnmount() {
        if (this.isScanning) {
           this.stopScanner();
        }
        window.removeEventListener("resize", this.setDynamicHeight);
    },
  };
  </script>
  
  <style scoped>
  .scanner-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: calc(100vh - 170px); /* Prispôsobenie výške */
  }
  </style>